import type { FieldDefinition, IntegrationProviderConfig } from '../../types';
import McpIcon from './McpIcon';

const pullObjectTypes = [{ label: 'List tools', value: 'list_tools' }];

const getPullFields = (_objectType: string): FieldDefinition[] => [];

export const mcpConfig: IntegrationProviderConfig = {
  id: 'mcp',
  name: 'MCP',
  icon: McpIcon,
  brandColor: '#FF9068',
  authMethod: 'apiKey',
  authFields: [
    {
      name: 'transport',
      label: 'How should we reach your MCP server?',
      type: 'select',
      options: [
        {
          label: 'Web address (HTTPS) — remote MCP',
          value: 'remote_http',
        },
        {
          label: 'Npm package — runs like a desktop MCP app, on our servers',
          value: 'stdio_npx',
        },
      ],
      defaultValue: 'remote_http',
      validation: { required: true },
    },
    {
      name: 'serverUrl',
      label: 'MCP server web address',
      type: 'text',
      placeholder: 'https://example.com/mcp',
      helperText:
        'Paste the full HTTPS URL from your provider. No coding required.',
      validation: { required: true },
      dependsOn: { field: 'transport', value: 'remote_http' },
    },
    {
      name: 'authToken',
      label: 'Secret token (only if your provider gave you one)',
      type: 'textarea',
      placeholder: 'Leave empty if the server does not ask for a bearer token',
      helperText:
        'Paste a raw token (we send it as Authorization: Bearer <token>), a full header like "Authorization: Bearer ...", or JSON like {"scheme":"Bearer","token":"..."} or {"headers":{"x-api-key":"..."}}.',
      dependsOn: { field: 'transport', value: 'remote_http' },
    },
    {
      name: 'stdioPackage',
      label: 'MCP package name',
      type: 'text',
      placeholder: '@modelcontextprotocol/server-github',
      helperText:
        'Copy the exact package name from the MCP server’s documentation (often starts with @modelcontextprotocol/).',
      validation: { required: true },
      dependsOn: { field: 'transport', value: 'stdio_npx' },
    },
    {
      name: 'stdioPackageVersion',
      label: 'Package version (optional)',
      type: 'text',
      placeholder: 'Leave empty to use the latest version',
      helperText:
        'Only fill this if your provider tells you to pin a specific version.',
      dependsOn: { field: 'transport', value: 'stdio_npx' },
    },
    {
      name: 'stdioSecrets',
      label: 'Authentication (optional)',
      type: 'textarea',
      placeholder: 'Token, API key, or paste from the package docs',
      helperText:
        'Optional. We turn whatever you paste into the right settings for the package above.',
      dependsOn: { field: 'transport', value: 'stdio_npx' },
    },
  ],
  pullConfig: {
    objectTypes: pullObjectTypes,
    getFields: getPullFields,
  },
  supportsPull: true,
  supportsPush: false,
};
